export const stepContentByPlan = {
	standard: {
		step1: {
			title: 'Welcome to The Godfrey Method',
			description: 'Get started with exercises, lessons, and across the floor videos.',
			features: ['Access to core training videos', 'Personal playlists', 'Multi-device support']
		},
		step2: {
			title: 'Explore Your Library',
			description: 'Browse through our curated collection of dance training content.',
			features: ['Exercises', 'Lessons', 'Across The Floor']
		},
		step3: {
			title: 'Create Your Playlists',
			description: 'Organize your favorite videos into custom playlists.',
			features: ['Personal playlists', 'Featured playlists', 'Easy video management']
		},
		step4: {
			title: 'Start Your Journey',
			description: 'You\'re all set to begin your dance training!',
			features: ['Track your progress', 'Save favorite videos', 'Access anywhere']
		}
	},
	plus: {
		step1: {
			title: 'Welcome to The Godfrey Method Plus',
			description: 'Unlock the full potential with complete access to all content.',
			features: ['Full video library access', 'Flexibility classes', 'Strength & technique classes']
		},
		step2: {
			title: 'Advanced Training',
			description: 'Access exclusive content designed for serious dancers.',
			features: ['6 new videos monthly', 'Advanced techniques', 'Professional training']
		},
		step3: {
			title: 'Maximize Your Training',
			description: 'Organize and track your advanced training sessions.',
			features: ['Custom playlists', 'Progress tracking', 'Priority content']
		},
		step4: {
			title: 'Ready to Excel',
			description: 'Everything you need to take your dancing to the next level.',
			features: ['Complete library', 'Regular updates', 'Premium support']
		}
	},
	studio: {
		step1: {
			title: 'Welcome to Studio Plan',
			description: 'Comprehensive solution for your entire studio.',
			features: ['Multi-user access', 'Studio playlists', 'Priority support']
		},
		step2: {
			title: 'Manage Your Studio',
			description: 'Tools designed specifically for studio owners and instructors.',
			features: ['User management', 'Studio playlists', 'Teacher Resource Center']
		},
		step3: {
			title: 'Collaborate with Your Team',
			description: 'Share content and playlists across your studio.',
			features: ['Shared playlists', 'Team collaboration', 'Individual tracking']
		},
		step4: {
			title: 'Virtual Classes & Support',
			description: 'Exclusive benefits for studio members.',
			features: ['FREE virtual class registration', 'Priority support', 'Regular updates']
		},
		step5: {
			title: 'Studio Setup',
			description: 'Configure your studio settings and invite team members.',
			features: ['Add studio members', 'Set permissions', 'Customize experience']
		},
		step6: {
			title: 'Teacher Resources',
			description: 'Access exclusive teaching materials and resources.',
			features: ['Lesson plans', 'Teaching guides', 'Resource library']
		}
	}
};

export const getPlanType = (planId) => {
	if (!planId) return 'standard';
	const upperPlanId = planId.toUpperCase();
	if (upperPlanId.startsWith('INDIVIDUAL')) return 'standard';
	if (upperPlanId.startsWith('VIP')) return 'plus';
	if (upperPlanId.startsWith('STUDIO')) return 'studio';
	return 'standard';
};
